import {Injectable} from '@angular/core';
import {FormControl, Validators, FormBuilder, FormGroup, AbstractControl} from "@angular/forms";

@Injectable()
export class ClienteModel {

  public clienteForm: any;

  public field: any = {

    //bloco dados gerais
    codcli: <string>'',
    nomcli: <string>'Sueli e Flávia Adega ME',
    apecli: <string>'Sueli e Flávia Adega ME',
    cgccpf: <string>'11799512000186',
    insest: <string>'558034134111',
    insmun: <string>'',
    foncli: <string>'(13)3473 - 2268',
    foncl2: <string>'',
    emanfe: <string>'M.SANTISTA@IG.COM.BR',
    intnet: <string>'m.santista@ig.com.br',
    filial: Array<string>(),
    tipcli: <string>'J',
    tipmer: <string>'I',
    clicon: <string>'S',
    confin: <string>'S', // apenas na hcl 28
    datcad: <string>'',
    sitcli: <string>'',
    stdesc: <string>'',

    favcli: <string>'',
    msglidas: <string>'',
    msgnaolidas: <string>'',

    //somente cliente interno
    codraiMI: <string>'',
    nomcidMI: <string>'',

    //bloco endereço principal
    codpai: <string>'1058',
    nompai: <string>'BRASIL',
    cepcli: <string>'11702200',
    codrai: <string>'3541000',
    nencli: <string>'1724',
    endcli: <string>'avenida presidente kennedy',
    baicli: <string>'campo da aviacao',
    cidcli: <string>'PRAIA GRANDE',
    sigufs: <string>'SP',
    cplend: <string>'',
    cliprx: <string>'',

    //bloco endereço cobrança
    cepcob: <string>'',
    nencob: <string>'',
    endcob: <string>'',
    baicob: <string>'',
    cidcob: <string>'',
    estcob: <string>'',
    cplcob: <string>'',

    //bloco endereço entrega
    cepent: <string>'',
    nenent: <string>'',
    endent: <string>'',
    baient: <string>'',
    cident: <string>'',
    estent: <string>'',
    cplent: <string>'',

    //bloco financeiro / fiscal
    codcrp: <string>'',
    codcpg: <string>'',
    codfcr: <string>'01',
    codsuf: <string>'',
    datsuf: <string>'',

    //bloco comercial
    codrep: <string>'9999',
    nomrep: <string>'',
    codven: <string>''

  };

  public cliMsgErroField = {
    'nomcli': [
      {type: 'required', tab: 0, message: 'Preencha o campo: <br><br> <span class="c-erro-msg">RAZÃO SOCIAL</span>'},
      {
        type: 'minlength',
        tab: 0,
        message: 'O campo <span class="c-erro-msg">RAZÃO SOCIAL</span> deve conter no mínimo 3 caracteres.'
      },
      {
        type: 'maxlength',
        tab: 0,
        message: 'O campo <span class="c-erro-msg">RAZÃO SOCIAL</span> deve conter no máximo 100 caracteres.'
      }
    ],
    'apecli': [
      {type: 'required', tab: 0, message: 'Preencha o campo: <br><br> <span class="c-erro-msg"> NOME FANTASIA</span>'},
      {
        type: 'minlength',
        tab: 0,
        message: 'O campo <span class="c-erro-msg">NOME FANTASIA</span> deve conter no mínimo 3 caracteres.'
      },
      {
        type: 'maxlength',
        tab: 0,
        message: 'O campo <span class="c-erro-msg">NOME FANTASIA</span> deve conter no máximo 50 caracteres.'
      }
    ],
    'emanfe': [
      {type: 'required', tab: 0, message: 'Preencha o campo: <br><br> <span class="c-erro-msg">E-MAIL NFE</span>'},
      {
        type: 'pattern',
        tab: 0,
        message: 'Endereço de e-mail informado no campo <span class="c-erro-msg">E-MAIL NFE</span> inválido.'
      },
      {
        type: 'maxlength',
        tab: 0,
        message: 'O campo <span class="c-erro-msg">E-MAIL NFE</span> deve conter no máximo 100 caracteres.'
      }
    ],
    'intnet': [
      {
        type: 'pattern',
        tab: 0,
        message: 'Endereço de e-mail informado no campo <span class="c-erro-msg"> E-MAIL CONTATO</span> inválido.'
      },
      {
        type: 'maxlength',
        tab: 0,
        message: 'O campo <span class="c-erro-msg">E-MAIL CONTATO</span> deve conter no máximo 100 caracteres.'
      }
    ],
    'foncli': [
      {
        type: 'required',
        tab: 0,
        message: 'Preencha o campo: <br><br> <span class="c-erro-msg"> TELEFONE PRINCIPAL</span>'
      },
      {
        type: 'minlength',
        tab: 0,
        message: 'O campo <span class="c-erro-msg">TELEFONE PRINCIPAL</span> deve conter no mínimo 8 caracteres.'
      },
      {
        type: 'maxlength',
        tab: 0,
        message: 'O campo <span class="c-erro-msg">TELEFONE PRINCIPAL</span> deve conter no máximo 20 caracteres.'
      }
    ],
    'foncli2': [
      {
        type: 'maxlength',
        tab: 0,
        message: 'O campo <span class="c-erro-msg">TELEFONE ALTERNATIVO</span> deve conter no máximo 20 caracteres.'
      }
    ],
    'nencli': [
      {type: 'required', tab: 1, message: 'Preencha o campo: <br><br> <span class="c-erro-msg"> Nº</span>'},
      {
        type: 'maxlength',
        tab: 1,
        message: 'O campo <span class="c-erro-msg">Nº</span> deve conter no máximo 60 caracteres.'
      }
    ],
    'endcli': [
      {type: 'required', tab: 1, message: 'Preencha o campo: <br><br> <span class="c-erro-msg"> ENDEREÇO</span>'},
      {
        type: 'minlength',
        tab: 1,
        message: 'O campo <span class="c-erro-msg">ENDEREÇO CODE</span> deve conter no mínimo 3 caracteres.'
      },
      {
        type: 'maxlength',
        tab: 1,
        message: 'O campo <span class="c-erro-msg">ENDEREÇO CODE</span> deve conter no máximo 100 caracteres.'
      }
    ],
    'baicli': [
      {type: 'required', tab: 1, message: 'Preencha o campo: <br><br> <span class="c-erro-msg"> BAIRRO</span>'},
      {
        type: 'minlength',
        tab: 1,
        message: 'O campo <span class="c-erro-msg">BAIRRO</span> deve conter no mínimo 3 caracteres.'
      },
      {
        type: 'maxlength',
        tab: 1,
        message: 'O campo <span class="c-erro-msg">BAIRRO</span> deve conter no máximo 75 caracteres.'
      }
    ],
    'cidcli': [
      {type: 'required', tab: 1, message: 'Preencha o campo: <br><br> <span class="c-erro-msg"> CIDADE</span>'},
      {
        type: 'minlength',
        tab: 1,
        message: 'O campo <span class="c-erro-msg">CIDADE</span> deve conter no mínimo 3 caracteres.'
      },
      {
        type: 'maxlength',
        tab: 1,
        message: 'O campo <span class="c-erro-msg">CIDADE</span> deve conter no máximo 60 caracteres.'
      }
    ],
    'sigufs': [
      {type: 'required', tab: 1, message: 'Preencha o campo: <br><br> <span class="c-erro-msg"> UF</span>'},
      {
        type: 'maxlength',
        tab: 1,
        message: 'O campo <span class="c-erro-msg">UF</span> deve conter no máximo 2 caracteres.'
      }
    ],
    'cplend': [
      {type: 'required', tab: 1, message: 'Preencha o campo: <br><br> <span class="c-erro-msg"> COMPLEMENTO</span>'},
      {
        type: 'minlength',
        tab: 1,
        message: 'O campo <span class="c-erro-msg">COMPLEMENTO</span> deve conter no mínimo 3 caracteres.'
      },
      {
        type: 'maxlength',
        tab: 1,
        message: 'O campo <span class="c-erro-msg">COMPLEMENTO</span> deve conter no máximo 200 caracteres.'
      }
    ]
  };

  constructor(public formBuilder: FormBuilder) {

    this.resetFormCliente();

    this.clienteForm = formBuilder.group({
      nomcli: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(100)]),
      apecli: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(50)]),
      emanfe: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$'), Validators.maxLength(100)]),
      intnet: new FormControl('', [Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$'), Validators.maxLength(100)]),
      foncli: new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(20)]),
      foncli2: new FormControl('', [Validators.maxLength(20)]),
      nencli: new FormControl('', [Validators.maxLength(60)]),
      endcli: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(100)]),
      baicli: new FormControl('', [Validators.maxLength(75)]),
      cidcli: new FormControl('', [Validators.maxLength(60)]),
      sigufs: new FormControl('', [Validators.required, Validators.maxLength(2)]),
      cplend: new FormControl('', [Validators.maxLength(200)]),
    });
  }

  resetFormCliente() {
    for (let prop in this.field) {
      if (prop != 'filial') {
        eval("this.field." + prop + " = '' ");
      } else {
        eval("this.field." + prop + " = [] ");
      }
    };
  }

}



// WEBPACK FOOTER //
// ./src/model/cliente.model.ts